// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../assets/images/nodata@2x.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".list-empty {\n  margin-top: 1.44rem;\n}\n.list-empty .list-empty-img {\n  width: 3.4rem;\n  height: 3.44rem;\n  margin: 0 auto;\n  background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") center no-repeat;\n  background-size: cover;\n}\n.list-empty > div:last-child {\n  margin-top: 0.32rem;\n  font-size: 0.28rem;\n  font-family: Microsoft YaHei;\n  font-weight: 400;\n  color: #888888;\n}\n", ""]);
// Exports
module.exports = exports;
